import { FC } from 'react';
import { DefaultCell, Icon, Icons, Tooltip } from '@silverfort/sf-components';
import { EmailColumnType } from '../types';

interface Props {
    email: EmailColumnType;
}

const EmailCell: FC<Props> = ({ email }) => {
    const renderIndicationIcon = () => {
        if (email.isExternal) {
            return (
                <Tooltip title="External Email">
                    <Icon className="text-sf-gray-500 shrink-0" size={20} icon={Icons.ExternalMail} />
                </Tooltip>
            );
        }

        if (email.isManualEmail) {
            return (
                <Tooltip title="Manually Added">
                    <Icon className="text-sf-gray-500 shrink-0" size={20} icon={Icons.UserEdit} />
                </Tooltip>
            );
        }

        return null;
    };

    return (
        <div className="pe-4 flex items-center min-w-[100px] gap-2">
            <div className="flex-1 min-w-0">
                <DefaultCell text={email.address} />
            </div>
            <div>{renderIndicationIcon()}</div>
        </div>
    );
};

export default EmailCell;
